import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSimBalance } from "../../../../global-account/react/index.js";
import { getChainLogo } from "../../../../shared/constants/chains/supported.js";
import { useActiveWallet } from "thirdweb/react";
import { TokenBalanceRow } from "./TokenBalanceRow.js";
// Chain logo URLs mapping
const CHAIN_LOGOS = [1, 8453, 8333].map(chainId => getChainLogo(chainId));
const TokenContent = () => {
  const $ = _c(7);
  const activeWallet = useActiveWallet();
  let t0;
  if ($[0] !== activeWallet) {
    t0 = activeWallet?.getAccount();
    $[0] = activeWallet;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeAccount = t0;
  const activeAddress = activeAccount?.address;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [8453, 8333, 1];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: simBalance
  } = useSimBalance(activeAddress, t1);
  console.log("simBalance :", simBalance);
  if (!activeAddress) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = _jsx("div", {
        className: "col-span-3 py-12 text-center text-gray-500",
        children: "No tokens found"
      });
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (!simBalance?.balances || simBalance.balances.length === 0) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = _jsx("div", {
        className: "col-span-3 py-12 text-center text-gray-500",
        children: "No tokens found"
      });
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== simBalance.balances) {
    const sortedBalances = [...simBalance.balances].sort(_temp);
    t2 = _jsx("div", {
      className: "flex max-h-[132px] flex-col gap-3 overflow-y-auto",
      children: sortedBalances.map(_temp2)
    });
    $[5] = simBalance.balances;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default TokenContent;
function _temp(a, b) {
  const valueA = a.value_usd || 0;
  const valueB = b.value_usd || 0;
  return valueB - valueA;
}
function _temp2(token, index) {
  const balance = (Number(token.amount) / Math.pow(10, token.decimals)).toFixed(4);
  const usdValue = token.value_usd?.toFixed(2) || "0.00";
  let tokenLogo = token.token_metadata?.logo || "";
  if (token.address === "native" && token.symbol === "ETH") {
    tokenLogo = CHAIN_LOGOS[0];
  }
  return _jsx(TokenBalanceRow, {
    tokenLogo,
    chainLogo: CHAIN_LOGOS[token.chain_id] || "",
    name: token.name || token.symbol,
    balance: `${balance} ${token.symbol}`,
    usdValue,
    priceChange: null
  }, `${token.chain_id}-${token.address}-${index}`);
}